import { Collapse, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { SETTELLMANT_CHECKLIST_DATA_MPKAY } from '../../constants/crmConstants';
import { GLOBAL_URL } from '../../constants/dataServiceUrl';
import FormSingleCheckbox from '../crmFormElement/FormSingleCheckbox/FormSingleCheckbox';

const DocumentChecklist = ({ form }: any): any => {
  const { Panel } = Collapse;
  const formControlConfig = useSelector((state: RootState): any => state?.payerList?.formControlConfig || {});
  const payerConfig = Object.values(formControlConfig);
  const isDocCheckList = !!(payerConfig?.filter(({ type, hidden }: any): boolean => type === 'DOC_CHECKLIST' && !hidden)).length;
  const columns: ColumnsType<any> = [
    {
      title: 'Sl. No.',
      dataIndex: 'index',
      width: '80px',
    },
    {
      title: 'Particulars',
      dataIndex: 'particular',
    },
  ];

  const onDownloadClick = (event: any): any => {
    event.stopPropagation();
    const fileName = 'MPKAY CHECK LIST FOR PROCESSING MEDICAL CLAIM';
    const linkSource = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}MPKAY_CHECK_LIST_FOR_PROCESSING_MEDICAL_CLAIM.docx`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  };

  const getExtraSection = (): ReactElement => {
    return (
      <span className="action-link" onClick={onDownloadClick}>
        <p className="mb-0">Download documents checklist</p>
      </span>
    );
  };

  const commonDetail = { form };

  return (
    isDocCheckList ?
      <React.Fragment>
        <Collapse className="mt-md mb-md" expandIconPosition="right" defaultActiveKey={['1']}>
          <Panel header="Documents checklist" key="1" extra={getExtraSection()}>
            <Table
              columns={columns}
              dataSource={SETTELLMANT_CHECKLIST_DATA_MPKAY || []}
              rowKey="index"
              size="small"
              pagination={false}
              className="mb-md"
            />
            <FormSingleCheckbox detail={{
              ...commonDetail,
              key: 'isDocChecklistVerified',
              hideLabel: true,
              size: 24,
              checkboxText: 'We confirm submission of all the above documents for facilitating claim processing of the patient.',
            }} />
          </Panel>
        </Collapse>
      </React.Fragment> : null
  );
};
export default DocumentChecklist;
